import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tabledebord',
  templateUrl: './tabledebord.component.html',
  styleUrls: ['./tabledebord.component.css']
})
export class TabledebordComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
